import { useEffect, useRef, useState } from "react";
import LoginService from "../../../core/services/login.service";
import { LocalStorageService } from "../../../helpers";
import * as actions from "../../../actions";
import { useDispatch } from "react-redux";
import { CustomToastMessage } from "../../../core/util/customToastMsg";
import { useTranslation } from "react-i18next";

const LoginGoogle = () => {
  const dispatch = useDispatch();
  const location = window.location;
  const hasHandledAuth = useRef(false);
  const accessTokenExp = LocalStorageService.getAccessToken();
  const [listProvider, setListProvider] = useState();
  const { t } = useTranslation();
  const parseGoogleAuthURL = (url) => {
    // Tách URL thành các phần
    const urlObj = new URL(url);

    // Parse state từ hash (vì nó nằm trong phần hash của URL)
    const hashParams = new URLSearchParams(urlObj.hash.substring(1));

    // Decode state object (là một JSON string được encode)
    const stateStr = hashParams.get("state");
    const stateObj = stateStr ? JSON.parse(decodeURIComponent(stateStr)) : null;

    // Lấy các params khác
    const params = {
      // Base URL info
      baseUrl: `${urlObj.protocol}//${urlObj.host}`,
      pathname: urlObj.pathname,

      // State object
      state: {
        d: stateObj?.d, // "edu"
        p: stateObj?.p, // 3
        r: stateObj?.r, // "http://localhost:3000/edu/login"
      },

      // Auth params
      access_token: hashParams.get("access_token"),
      token_type: hashParams.get("token_type"),
      expires_in: parseInt(hashParams.get("expires_in")),
      scope: decodeURIComponent(hashParams.get("scope")),
      authuser: hashParams.get("authuser"),
      prompt: hashParams.get("prompt"),
    };

    // Tách scope thành array
    const scopes = params.scope.split(" ");

    return {
      ...params,
      scopes,

      // Helper methods
      getBaseInfo: () => ({
        baseUrl: params.baseUrl,
        pathname: params.pathname,
      }),

      getStateInfo: () => params.state,

      getAuthInfo: () => ({
        access_token: params.access_token,
        token_type: params.token_type,
        expires_in: params.expires_in,
        authuser: params.authuser,
        prompt: params.prompt,
      }),

      getScopeInfo: () => ({
        rawScope: params.scope,
        scopeArray: scopes,
      }),
    };
  };
  const parsedURL = parseGoogleAuthURL(location.href);
  const fetchDataProvider = async () => {
    await LoginService.getListProvider()
      .then((res) => {
        setListProvider(res.data[0]);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const getGoogleAuth = () => {
    if (listProvider) {
      const stateObj = {
        d: process.env.REACT_APP_DB_SERVER || 'isb',
        p: listProvider.id,
        r: `${location.origin}${location.pathname}`
      };
      const stateStr = encodeURIComponent(JSON.stringify(stateObj));
      window.location.href = `${listProvider.auth_endpoint}?response_type=token&client_id=${listProvider.client_id}&redirect_uri=${location.origin}${location.pathname}&scope=${listProvider.scope}&state=${stateStr}`;
    }
  };
  const handleLogGG = async () => {
    const access_token = parsedURL.access_token;
    const state = parsedURL.state;
    await LoginService.getToken({ access_token, state })
      .then((res) => {
        LocalStorageService.setToken(res);
        LocalStorageService.setRefreshToken(res);
        window.location.href = `/payment/detail`;
      })
      .catch((err) => {
        window.location.href = "/404page";
      });
  };

  useEffect(() => {
    if (!accessTokenExp) {
      dispatch(actions.authLogout());
    }
    fetchDataProvider();
  }, []);
  useEffect(() => {
    if (parsedURL.access_token && !hasHandledAuth.current) {
      hasHandledAuth.current = true;
      // Xoá hash khỏi URL để khi reload không bị gửi request login cũ lên Odoo
      window.history.replaceState({}, document.title, location.pathname);
      fetchDataProvider();
      handleLogGG();
    }
  }, [parsedURL]);
  return (
    <button
      type="button"
      style={{
        gap: "8px",
        borderRadius: "10px",
        border: "1px solid #E3E3E3",
        backgroundColor: "#fff",
        fontSize: "16px",
        fontWeight: "bold",
        color: "#232323",
        padding: "16px",
      }}
      onClick={getGoogleAuth}
      className="flex w-full items-center justify-center"
    >
      {t("login_google")}
      <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Group">
          <path
            id="Shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.16 8.69176C17.16 8.08904 17.1059 7.50949 17.0055 6.95312H9V10.2411H13.5746C13.3775 11.3036 12.7786 12.2038 11.8784 12.8065V14.9393H14.6255C16.2327 13.4595 17.16 11.2804 17.16 8.69176Z"
            fill="#4285F4"
          />
          <path
            id="Shape_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.99997 16.9983C11.295 16.9983 13.2191 16.2372 14.6254 14.939L11.8784 12.8062C11.1173 13.3162 10.1436 13.6176 8.99997 13.6176C6.78611 13.6176 4.91224 12.1224 4.24383 10.1133H1.40405V12.3156C2.80269 15.0935 5.67724 16.9983 8.99997 16.9983Z"
            fill="#34A853"
          />
          <path
            id="Shape_3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.24387 10.1159C4.07387 9.60587 3.97728 9.0611 3.97728 8.50087C3.97728 7.94064 4.07387 7.39587 4.24387 6.88587V4.68359H1.40409C0.82841 5.8311 0.5 7.12928 0.5 8.50087C0.5 9.87247 0.82841 11.1706 1.40409 12.3182L4.24387 10.1159Z"
            fill="#FBBC05"
          />
          <path
            id="Shape_4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.99997 3.38069C10.2479 3.38069 11.3684 3.80955 12.2493 4.65183L14.6873 2.21387C13.2152 0.842274 11.2911 0 8.99997 0C5.67724 0 2.80269 1.90478 1.40405 4.68273L4.24383 6.88501C4.91224 4.87592 6.78611 3.38069 8.99997 3.38069Z"
            fill="#EA4335"
          />
        </g>
      </svg>
    </button>
  );
};
export default LoginGoogle;
